import { Link } from "react-router-dom";
import { CalendarDays, Clock, UserPlus } from "lucide-react";

const STEPS = [
  { icon: UserPlus, title: "Create an account", text: "Sign up once so you can manage your sessions." },
  { icon: CalendarDays, title: "Pick a weekday", text: "Any Monday to Friday, with an optional space." },
  { icon: Clock, title: "Lock your session", text: "Morning, afternoon or evening — first come, first served." },
];

export const HowItWorks = () => (
  <section className="mx-auto max-w-7xl px-6 py-24 md:px-12" data-testid="how-it-works-section">
    <p className="eyebrow">How it works</p>
    <div className="mt-10 grid gap-10 md:grid-cols-3">
      {STEPS.map(({ icon: Icon, title, text }, i) => (
        <div key={title} className="border-l border-white/10 pl-6">
          <span className="font-tech text-xs text-zinc-600">0{i + 1}</span>
          <Icon className="mt-4 h-6 w-6 text-[#FF3333]" />
          <h3 className="mt-4 font-display text-xl font-semibold uppercase text-white">{title}</h3>
          <p className="mt-2 text-sm text-zinc-400">{text}</p>
        </div>
      ))}
    </div>
    <div className="mt-16 flex flex-col items-start justify-between gap-6 rounded-md border border-[#FF3333]/30 bg-[#FF3333]/[0.06] p-8 md:flex-row md:items-center md:p-12">
      <p className="font-display text-2xl font-bold uppercase text-white md:text-3xl">Ready to hit record?</p>
      <Link to="/book" className="btn-riot" data-testid="cta-book-btn">Book Riot Factory</Link>
    </div>
  </section>
);
